import { createReducer, on } from "@ngrx/store";
import { IBusquedaInitState, IBusquedaState } from "../../interfaces/busqueda";
import {
  buscarEntradaFail,
  buscarEntradaSuccess,
  loadEntradaSeleccionada,
  loadingEntradasSuccess,
  resetBusqueda,
} from "./actions";

export const initialState: IBusquedaState = IBusquedaInitState;

export const busquedaReducer = createReducer(
  initialState,
  on(
    buscarEntradaSuccess,
    (state, { ids, busqueda, pages, currentPage, tipoBusqueda }) => {
      return {
        ...state,
        ids: [...state.ids, ...ids],
        error: false,
        busqueda,
        pages,
        currentPage,
        tipoBusqueda,
      };
    }
  ),
  on(buscarEntradaFail, (state) => {
    return { ...state, ids: [], error: true };
  }),
  on(loadingEntradasSuccess, (state, { entradas, currentPage }) => {
    return {
      ...state,
      entradas: [...state.entradas, ...entradas],
      currentPage,
      error: false,
    };
  }),
  on(loadEntradaSeleccionada, (state, { entrada }) => {
    return {
      ...state,
      entradaSeleccionada: entrada,
    };
  }),
  on(resetBusqueda, (state) => {
    return initialState;
  })
);
